import type { PayloadAction, SliceCaseReducers } from "@reduxjs/toolkit";
import type {
  SpecsEditorSession,
  SpecsLayerRuntimeState,
} from "../../../../containers/SpecsEditor/types";
import {
  createEmptyNav,
  createFirstAvailableLayerNav,
  createPositionsNav,
  createScopedNav,
  touch,
} from "../helpers";
import { defaultSession } from "./session";

function hydrateModelLayerState(
  state: SpecsEditorSession,
  payload: {
    layerRuntimeByKey: Record<string, SpecsLayerRuntimeState>;
    layerRuntimeOrder: string[];
  }
) {
  const apiKey = state.falSettings.apiKey;
  const fresh = defaultSession();
  Object.assign(state, fresh);
  state.falSettings.apiKey = apiKey;

  state.layerRuntimeByKey = payload.layerRuntimeByKey;
  state.layerRuntimeOrder = payload.layerRuntimeOrder;

  state.nav = createFirstAvailableLayerNav(state) ?? createEmptyNav(state);
  touch(state);
}

function refreshModelLayerState(
  state: SpecsEditorSession,
  payload: {
    layerRuntimeByKey: Record<string, SpecsLayerRuntimeState>;
    layerRuntimeOrder: string[];
  }
) {
  const previousNav = state.nav;
  state.layerRuntimeByKey = payload.layerRuntimeByKey;
  state.layerRuntimeOrder = payload.layerRuntimeOrder;

  if (
    previousNav.kind === "layer" ||
    previousNav.kind === "element" ||
    previousNav.kind === "positions"
  ) {
    const partName = previousNav.part;
    const elementName = previousNav.element;
    const styleName = previousNav.style;
    if (partName && elementName) {
      state.nav =
        previousNav.kind === "positions"
          ? createPositionsNav(state, {
              positionId: previousNav.positionId,
              partName,
              elementName,
              styleName,
            })
          : createScopedNav(state, partName, elementName, styleName);
    }
  }

  touch(state);
}

export const productReducers = {
  hydrateModelLayers(
    state,
    {
      payload,
    }: PayloadAction<{
      layerRuntimeByKey: Record<string, SpecsLayerRuntimeState>;
      layerRuntimeOrder: string[];
    }>
  ) {
    hydrateModelLayerState(state, payload);
  },
  refreshModelLayers(
    state,
    {
      payload,
    }: PayloadAction<{
      layerRuntimeByKey: Record<string, SpecsLayerRuntimeState>;
      layerRuntimeOrder: string[];
    }>
  ) {
    refreshModelLayerState(state, payload);
  },
} satisfies SliceCaseReducers<SpecsEditorSession>;
